import { Badge, Group } from "@mantine/core";
import { SEGMENT_LABELS } from "../lib/format";

interface Props {
  segments: string[];
  max?: number;
}

export function SegmentOverflow({ segments, max = 2 }: Props) {
  const shown = segments.slice(0, max);
  const extra = segments.length - shown.length;
  if (segments.length === 0) {
    return "—";
  }
  return (
    <Group gap="var(--axio-unit-4)" wrap="nowrap">
      {shown.map((code) => (
        <Badge key={code} size="xs" variant="outline" color="gray">
          {SEGMENT_LABELS[code] ?? code}
        </Badge>
      ))}
      {extra > 0 && (
        <Badge size="xs" variant="light" color="gray">
          +{extra}
        </Badge>
      )}
    </Group>
  );
}
